import { ReactNode } from 'react';

export interface ButtonTrayProps {
  children: ReactNode;
}

const ButtonTray: React.FunctionComponent<ButtonTrayProps> = function ({
  children,
}) {
  return (
    <div className="sticky md:absolute w-full max-w-[1440px] h-0 bg-purple-50 bottom-0 md:left-1/2 md:-translate-x-1/2">
      <div className="absolute right-8 bottom-8 md:right-10 md:bottom-10 flex flex-row gap-x-4 md:gap-x-6 ">
        {children}
      </div>
    </div>
  );
};

export default ButtonTray;
